import {
  wrapRootElement as wrap,
  onInitialClientRender as init,
} from "./root-wrapper"

export const wrapRootElement = wrap
export const onInitialClientRender = init
